export default __webpack_public_path__ + "e52e7d9b9ef61bc5b90f42ee7685e292.jpg";